<script lang="ts">
    import { DEFAULT_LAYOUT } from '$lib/components/constants';
    import { onMount } from 'svelte';
    import { personalizeText, getColor } from '$lib/helper';

    // Types
    import type { TrackingProperty } from '$lib/types/TrackingProperty';
    import type { ComponentType } from 'svelte';
    import type { TextContent } from '$lib/types/Components/Text/TextContent';
    import type { Theme } from '$lib/types/Theme';
    import type { Language } from '$lib/types/Language';

    export let content: TextContent;
    export let theme: Theme;
    export let transitionDelay: number;
    export let transitionEffect = 'default';
    export let campaignId: string;
    export let trackingProperties: TrackingProperty[];
    export let language: Language = 'de';
    export let layout = DEFAULT_LAYOUT;

    let personalizedText = content.wysiwyg;

    let Text: ComponentType;

    onMount(async () => {
        Text = (await import('$lib/components/_DisplayComponents/Text.svelte')).default;
    });

    $: personalizedText = personalizeText(
        content.wysiwyg,
        trackingProperties,
        campaignId,
        language,
    );
</script>

<svelte:component
    this={Text}
    raw={personalizedText}
    align={content.align}
    color={getColor(content.color, theme.fontColor)}
    box={content.box}
    linkColor={theme.buttonBackgroundColor}
    {transitionDelay}
    {transitionEffect}
    {layout}
/>
